<script setup lang="ts">
import { watch } from 'vue';
import { RouterView, useRoute, useRouter } from 'vue-router';

import Toaster from '@/components/ui/Toaster.vue';
import { useAccountStore } from '@/stores/account';

const account = useAccountStore();
const router = useRouter();
const route = useRoute();

watch(
  () => account.account,
  (next, prev) => {
    // Login transition while on the public home screen → into the app.
    // Gated on `route.name === 'home'` only: during the very first navigation
    // the route is still uncommitted (name `undefined`, path `/`), so this must
    // not hijack a deep link such as the public chat at /c/:slug. A fresh load
    // at `/` while already authed is handled by the router guard instead.
    if (next && !prev && route.name === 'home') {
      // A brand-new account lands in Dimmitri onboarding; a returning login
      // goes straight to the dashboard.
      const target = account.justRegistered ? 'onboarding' : 'dashboard';
      account.justRegistered = false;
      void router.push({ name: target });
    } else if (!next && prev) {
      void router.push({ name: 'home' });
    }
  },
);
</script>

<template>
  <RouterView />
  <Toaster />
</template>
